import { graphql, useStaticQuery } from 'gatsby'
import  HighlightedNews  from './HighlightedNews'
import  HubspotBrochureDownload   from '../HubspotBrochureDownload'

const News = () => {

    const data = useStaticQuery(graphql`query newsQuery {
  allGhostPost(
    sort: {published_at: DESC}
    filter: {tags: {elemMatch: {name: {eq: "#news"}}}}
  ) {
    nodes {
      id
      title
      slug
      tags {
        name
        slug
      }
      feature_image
      excerpt
      url
      html
    }
  }
}`)

    //console.log(data.allGhostPost.nodes)
    const items = []
    {data.allGhostPost.nodes.map((post, index) => {
        const url = `${post.slug}/`
       // console.log(items)

        items.push(
            <article className=" col-12 col-sm-6 col-md-6 col-lg-6 item d-left headpost" key={index}>
                <div className="shadowN box-shadow bg-white brad-16 p-4">
                    <div className="overflow img-responsive brad-16">
                        <div className="featured-image" title={ post.title }>
                        <img width="340" height="" className="img-responsive lozad" src={ post.feature_image } alt={ post.title} loading="lazy"/>
                        </div>
                    </div>
                    <div className="post_titel">{ post.title }</div>
                    <div className="blog_excerpt" >{ post.excerpt }</div>
                    <div className = "readm"><div dangerouslySetInnerHTML={{ __html: post.html }} ></div></div>
                </div>
            </article>)
    })}

    return (<>

        <section className="greyBackgroundN faqN NewsPage">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-8 col-md-8 col-xs-12 col-sm-8 newsItem">
                      {items}
                    </div>
                    <div className="col-lg-4 col-md-4 col-xs-12 col-sm-4 highlighted ">
                        <h2>Highlighted News</h2>
                        <div><HighlightedNews  src='highlightednews'/></div>
                        <div className="downloadsection text-center sticky innerspace compny_background hidden-xs hidden-sm">
                        <div className="sideheading">Download our eBook for Free</div>
                        <div className="b15">A Complete Guide To Corporate Wellness Programs</div>
                        <div className="transform "><a className="popup-youtube banner_btn white_button button-style color_white" href="https://www.vantagefit.io/vantagefit-corporate-wellness-guide/"  >Free Download </a>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <section className="sectionSpacing featuresDetailsShape newsP">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                    <div className="colorwhite mainHeadingN">Stay updated with the latest trends</div>
                        <p className="colorwhite">Get our latest corporate wellness content right in your inbox.</p>

                        <div className = "newsForm"><HubspotBrochureDownload formID="1fab61f2-748b-4322-8a07-bd1ff6f1f18a"/></div>

                    </div>
                </div>
            </div>
        </section> */}
        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                    Stay updated with the latest trends
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 text-white">
                    Get our latest corporate wellness content right in your inbox.
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <div className = "newsForm"><HubspotBrochureDownload formID="1fab61f2-748b-4322-8a07-bd1ff6f1f18a"/></div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default News

